var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrUpGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chevron-up"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.41042 6.07757C9.73586 5.75214 10.2635 5.75214 10.5889 6.07757L16.4223 11.9109C16.7477 12.2363 16.7477 12.764 16.4223 13.0894C16.0968 13.4149 15.5692 13.4149 15.2438 13.0894L9.99967 7.84534L4.7556 13.0894C4.43016 13.4149 3.90252 13.4149 3.57709 13.0894C3.25165 12.764 3.25165 12.2363 3.57709 11.9109L9.41042 6.07757Z",
    fill: "#666666"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrUpGray);
export default __webpack_public_path__ + "static/media/arr_up_gray.9444746e298a51d1773541c0978eaf37.svg";
export { ForwardRef as ReactComponent };